import { CircularProgress } from "./CircularProgress";
import { competencyIcons } from "./CompetencyIcons";
import type { ScoreTag } from "../Data/reportData";

interface CompetencyCardProps {
  name: string;
  icon: string;
  score: number;
  tag: ScoreTag;
}

const tagColors: Record<ScoreTag, string> = {
  Fair: "",
  Skilled: "#A5F3FC",
  Pro: "#22D3EE",
};

const tagStyles: Record<ScoreTag, string> = {
  Fair: "text-muted-foreground",
  Skilled: "",
  Pro: "",
};

export function CompetencyCard({ name, icon, score, tag }: CompetencyCardProps) {
  const IconComponent = competencyIcons[name];
  
  return (
    <div className="group relative p-4 rounded-xl bg-card/70 border border-border hover:border-cyan/40 hover:scale-[1.02] hover:-translate-y-0.5 hover:shadow-lg hover:shadow-cyan/20 hover:bg-card/90 transition-all duration-300 card-glow cursor-pointer">
      {/* Content */}
      <div className="flex items-center gap-4">
        {/* Icon in black square container */}
        <div className="w-14 h-14 rounded-lg bg-gradient-to-br from-slate-900 to-black flex items-center justify-center border border-cyan/20 ring-1 ring-inset ring-white/5 group-hover:border-cyan/40 transition-all duration-300">
          {IconComponent ? (
            <IconComponent />
          ) : (
            <span className="text-lg text-foreground">{icon}</span>
          )}
        </div>
        
        {/* Name + Tag */}
        <div className="flex-1 flex flex-col gap-1">
          <span className="text-base font-medium text-foreground">{name}</span>
          <span
            className={`text-[12px] font-medium uppercase tracking-[0.2em] ${tagStyles[tag]}`}
            style={tagColors[tag] ? { color: tagColors[tag] } : undefined}
          >
            {tag}
          </span>
        </div>
        
        {/* Ring chart */}
        <CircularProgress score={score} size="sm" />
      </div>
    </div>
  );
}
